// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestList_container__EMMBn {
  height: 45rem;
  flex-wrap: wrap;
  /* width: 45rem; */
}

.RequestList_headerContainer__Mmuaf {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.RequestList_row__zIyoZ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: none;
}

.RequestList_textContainer__4KBkz {
  padding: 10px; 
  width: 100%;
}

.RequestList_text1__fUH43 {
  font-weight: 600;
  font-size: 20px;
  padding-bottom: 0.5rem;
  color: #333;
}

.RequestList_text2__MqCUV {
  font-weight: 300;
  font-size: 15px;
  color: #666;
}

.RequestList_text2t__XhcR7 {
  font-weight: 600;
  font-size: 16px;
  color: #666;
}

.RequestList_card__0xsfW {
  margin: 10 10px;
  width: calc(100% - 20px);
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.RequestList_cardText__JbFfT{
  width: calc(100% - 8rem); 
}

.RequestList_status__H9JNd {
  font-size: 0.8rem;
  border: 1px solid #428ace;
  border-radius: 0.5rem;
  background-color: #5a9bd846;
  padding: 0.1rem 0.5rem;
  align-self: flex-end;
  color: #000000;
  margin-left: auto;
}

.RequestList_image__\\+iOKd {
  margin: 0.4rem;
  height: 3rem;
  width: 3rem;
  border-radius: 5rem;
}

.RequestList_subContainer__LWjMx {
  display: flex;
  justify-content: left;
  align-items: center;
}


.RequestList_buttonContainer__PHPSd {
  padding-top: 10px;
  margin-top: 0rem;
  display: flex;
  justify-content: space-between;
}

.RequestList_verifyButtonContainer__w0fou {
  display: flex;
}

.RequestList_verifyButton__YpJUS {
  margin-right: 3px;
}

.RequestList_rightButtonContainer__wHTao {
  display: flex;
}

.RequestList_completeButton__Qn2v6 {
  margin-left: 3px;
}

`, "",{"version":3,"sources":["webpack://./src/Components/Requests/RequestList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\r\n  height: 45rem;\r\n  flex-wrap: wrap;\r\n  /* width: 45rem; */\r\n}\r\n\r\n.headerContainer {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  box-shadow: none;\r\n}\r\n\r\n.textContainer {\r\n  padding: 10px; \r\n  width: 100%;\r\n}\r\n\r\n.text1 {\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  padding-bottom: 0.5rem;\r\n  color: #333;\r\n}\r\n\r\n.text2 {\r\n  font-weight: 300;\r\n  font-size: 15px;\r\n  color: #666;\r\n}\r\n\r\n.text2t {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #666;\r\n}\r\n\r\n.card {\r\n  margin: 10 10px;\r\n  width: calc(100% - 20px);\r\n  border: 1px solid #ccc;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  margin-top: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.cardText{\r\n  width: calc(100% - 8rem); \r\n}\r\n\r\n.status {\r\n  font-size: 0.8rem;\r\n  border: 1px solid #428ace;\r\n  border-radius: 0.5rem;\r\n  background-color: #5a9bd846;\r\n  padding: 0.1rem 0.5rem;\r\n  align-self: flex-end;\r\n  color: #000000;\r\n  margin-left: auto;\r\n}\r\n\r\n.image {\r\n  margin: 0.4rem;\r\n  height: 3rem;\r\n  width: 3rem;\r\n  border-radius: 5rem;\r\n}\r\n\r\n.subContainer {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n\r\n.buttonContainer {\r\n  padding-top: 10px;\r\n  margin-top: 0rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.verifyButtonContainer {\r\n  display: flex;\r\n}\r\n\r\n.verifyButton {\r\n  margin-right: 3px;\r\n}\r\n\r\n.rightButtonContainer {\r\n  display: flex;\r\n}\r\n\r\n.completeButton {\r\n  margin-left: 3px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RequestList_container__EMMBn`,
	"headerContainer": `RequestList_headerContainer__Mmuaf`,
	"row": `RequestList_row__zIyoZ`,
	"textContainer": `RequestList_textContainer__4KBkz`,
	"text1": `RequestList_text1__fUH43`,
	"text2": `RequestList_text2__MqCUV`,
	"text2t": `RequestList_text2t__XhcR7`,
	"card": `RequestList_card__0xsfW`,
	"cardText": `RequestList_cardText__JbFfT`,
	"status": `RequestList_status__H9JNd`,
	"image": `RequestList_image__+iOKd`,
	"subContainer": `RequestList_subContainer__LWjMx`,
	"buttonContainer": `RequestList_buttonContainer__PHPSd`,
	"verifyButtonContainer": `RequestList_verifyButtonContainer__w0fou`,
	"verifyButton": `RequestList_verifyButton__YpJUS`,
	"rightButtonContainer": `RequestList_rightButtonContainer__wHTao`,
	"completeButton": `RequestList_completeButton__Qn2v6`
};
export default ___CSS_LOADER_EXPORT___;
